"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearsCache = void 0;
function ClearsCache(cacheName, numberOfArguments) {
    return function (target, propName, descriptor) {
        const origFn = descriptor.value;
        descriptor.value = async function (...params) {
            const result = await origFn.apply(this, params);
            const args = numberOfArguments === undefined ? params.slice() : params.slice(0, numberOfArguments);
            this.removeFromCache([cacheName, ...args], true);
            return result;
        };
        return descriptor;
    };
}
exports.ClearsCache = ClearsCache;
//# sourceMappingURL=ClearsCache.js.map